import { object, string } from 'yup';
import { TFunction } from 'i18next';

export function makeLoginSchema(t: TFunction) {
  return object().shape({
    email: string().email(t('form.emailInvalid')).required(t('form.required')),
    password: string().required(t('form.required')),
  });
}
